import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/Axelerate_logo.svg'


const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center rounded bg-background" }
const _hoisted_2 = { class: "flex flex-col bg-white lg:shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-lg w-full max-w-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pt-5 pb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "login logo",
    class: "w-5/12 lg:pb-5"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "h-1/4 w-1/4 text-green-400",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      })
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold self-start text-xl sm:text-2xl text-gray" }, " Payment Successful ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mt-5 mb-3 text-black text-sm overflow-clip tracking-normal text-left" })
], -1)
const _hoisted_6 = { class: "flex w-full mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('/')),
            class: "flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-primary rounded-full py-2 w-full transition duration-150 ease-in h-14 btn-submit"
          }, " Go to Home ")
        ])
      ])
    ])
  ]))
}